import { render, staticRenderFns } from "./UAUView.vue?vue&type=template&id=15fbfd04&"
import script from "./UAUView.vue?vue&type=script&lang=js&"
export * from "./UAUView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports